module.exports = __webpack_public_path__ + "no-results.png?1e5d00e7b414b2d4d4a36488a719e42a";